import { type Timeframe } from './useStudentGenerateMessageMutation';

export type RangeOption = '7d' | '30d' | '1m' | '3m';

export type ApiDateParams =
  | { range: RangeOption; start?: never; end?: never }
  | { start: string; end: string; range?: never };

export function timeframeToApiParams(timeframe: Timeframe, periodCreatedAt: string): ApiDateParams {
  const today = new Date().toISOString().slice(0, 10);
  switch (timeframe) {
    case 'today':
      return { start: today, end: today };
    case 'week':
      return { range: '7d' };
    case 'month':
      return { range: '30d' };
    case '3months':
      return { range: '3m' };
    case 'all':
      return { start: periodCreatedAt.slice(0, 10), end: today };
  }
}
